import React from "react";
import Table from "../../../../../../common/element/Table";
import moment from "moment/moment";
const { Tr, Th, Td, THead, TBody } = Table;
const OverallRevenueList = ({ data, handleSort, getAllinvitedData }) => {
  return (
    <React.Fragment>
      <div className="overflow-hidden border rounded-lg border-gray-200">
        <Table>
          <THead>
            <Tr>
              <Th>Invoice no.</Th>
              <Th>Type</Th>
              <Th>Trading name</Th>
              <Th>Paid by</Th>
              <Th>Fee type</Th>
              <Th>New/Renewal</Th>
              <Th>Invoice status</Th>
              <Th>Amount</Th>
              <Th>Due date</Th>
              <Th>Raised date</Th>
              <Th>Payment date</Th>
            </Tr>
          </THead>
          <TBody>
            {data?.clientInvoice?.length > 0 &&
              data?.clientInvoice?.map((item, index) => {
                return (
                  <Tr key={index}>
                    <Td>{item?.invoice_no}</Td>
                    <Td>{item?.client_org_id? "Client" : "Provider"}</Td> 
                    <Td>{item?.client_trading_name ? item?.client_trading_name : item?.provider_trading_name}</Td> {/* Assuming client_trading_name is provided in your actual data */}
                    <Td>{item?.paid_by}</Td> {/* Assuming paid_by is provided in your actual data */}
                    <Td>{item?.fee_type}</Td>
                    <Td>{item?.new_or_renewal || "-"}</Td> {/* If new_or_renewal is null, show "-" */}

                    <Td>
                      <span
                        className={
                          item?.invoice_status !== "OVERDUE"
                            ? "badge bg-success-50 text-success-700 py-0.5 px-2 rounded-lg font-medium"
                            : "badge bg-error-100 text-error-700 py-0.5 px-2 rounded-lg font-medium"
                        }
                      >
                        {item?.invoice_status}
                      </span>
                    </Td>
                    <Td>{ `$ ${item?.amount}` || 0}</Td> {/* If amount is null or undefined, show 0 */}
                    <Td>
                      {item?.due_date
                        ? moment(item?.due_date).format("DD/MM/YYYY")
                        : "-"} {/* Format the due date or show "-" if not available */}
                    </Td>
                    <Td>
                      {item?.raised_date
                        ? moment(item?.raised_date).format("DD/MM/YYYY")
                        : "-"} {/* Format the raised date or show "-" if not available */}
                    </Td>
                    <Td>
                      {item?.payment_date
                        ? moment(item?.payment_date).format("DD/MM/YYYY")
                        : "-"} {/* Format the payment date or show "-" if not available */}
                    </Td>
                  </Tr>
                );
              })}
          </TBody>
        </Table>

      </div>
    </React.Fragment>
  );
};
export default OverallRevenueList;
